/**
 * Sync the installed PWA app icon badge with unread notification count.
 * No-op when Badging API is unavailable.
 */
export async function syncAppBadge(count) {
	if (typeof navigator === "undefined") {
		return;
	}

	const n = Math.max(0, Number(count) || 0);

	try {
		if (n > 0 && typeof navigator.setAppBadge === "function") {
			await navigator.setAppBadge(n);
			return;
		}
		if (typeof navigator.clearAppBadge === "function") {
			await navigator.clearAppBadge();
		}
	} catch (error) {
		console.debug("App badge sync skipped:", error);
	}
}
